export default function useOwnerCommon() {
  const localePath = useLocalePath()
  const { isLoggedIn } = useAuthentication()

  const linkListRv = computed(() => {
    if (isLoggedIn.value) {
      return localePath({ name: 'dashboard-rvs-new', params: { dashboard: 'host' } })
    }
    return localePath({ name: 'owner' })
  })

  return {
    linkListRv,
  }
}
